import { facadeApi } from 'api'
import { AzGroup, GroupFormCreateDTO } from 'types/groups/groups'

interface Params {
  group: GroupFormCreateDTO
}

export const createGroupApi = ({ group }: Params) => facadeApi.post<AzGroup>('/az/groups', group)
